import { render, staticRenderFns } from "./Soon.vue?vue&type=template&id=4f5492c3&scoped=true&"
import script from "./Soon.vue?vue&type=script&lang=js&"
export * from "./Soon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5492c3",
  null
  
)

export default component.exports